<app-header></app-header>
<div class="content_wrapper">
    <div class="panel-source-view">
        <div class="an-top">
            <div class="summary-mentions">
                <div class="spinner-border"></div>
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a (click)="active_tab('profile')" class="nav-link active" data-toggle="tab" id="public-tab" href="#public_tbl" role="tab">Public profiles</a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a (click)="active_tab('page')" class="nav-link" data-toggle="tab" id="page-tab"  href="#page_tbl" role="tab">Pages</a>
                    </li>
                </ul>
            </div>
            <div class="bt-top">
                <!--<button type="button" class="submit-mention btn">Filter Mentions</button>-->
                <div class="popover-wrapper">
                    <input type="text"
                           ngxDaterangepickerMd
                           [(ngModel)]="selected"
                           [alwaysShowCalendars]="alwaysShowCalendars"
                           [ranges]="ranges"
                           [showClearButton]="true"
                           [showCancel]="true"
                           [linkedCalendars]="true"
                           [locale]="{applyLabel: 'Apply'}"
                           (datesUpdated)="datesUpdated($event)"
                           [keepCalendarOpeningWithRange]="keepCalendarOpeningWithRange"
                           [showRangeLabelOnInput]="showRangeLabelOnInput"
                           class="form-control"/>
                </div>
            </div>
        </div>

        <!--table main source--->
        <div class="panel-source-main">
            <div class="summary-mentions source">
                <div class="spinner-border"></div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="public_tbl" role="tabpanel" aria-labelledby="public-tab">
                        <div class="pop-content pub-content">
                            <div class="pre-loader">
                                <div class="table_public">
                                    <table class="table table-striped" infiniteScroll
                                           [infiniteScrollThrottle]="50"
                                           infiniteScrollThrottle="300"
                                           infiniteScrollDistance="0.5"
                                           (scrolled)="onScroll()">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Profile name</th>
                                                <th>Site</th>
                                                <th>Mentions</th>
                                                <th>Engagement</th>
                                                <th>Likes</th>
                                                <!--                                                <th>Influence</th>
                                                                                                <th>Influence Score</th>
                                                                                                <th>Options</th>-->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let mention of public_profiles; let i = index" [style.display]="can_show_mention(mention.id, mention.profile_id)">
                                                <td>{{i+1}}</td>
                                                <td><a href="{{mention.profile_link}}" target="_blank">{{mention.name}}</a></td>
                                                <td><img src="{{get_social_icon(mention.mchannel)}}"></td>
                                                <td>{{mention.total_count}}</td>
                                                <td>{{mention.mEngagement}}</td>
                                                <td>{{mention.likes}}</td>
                                                <!--                                                <td>john@example.com</td>
                                                                                                <td>John</td>
                                                                                                <td>Doe</td>-->
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div> 
                        <div class="show-more">
                            <div class="spinner-border popular" [style.display]="section_loader ? 'block' : 'none'"></div>
                            <!--<button type="button" class="submit-mention btn" (click)="show_more_profiles()">Show More</button>-->
                        </div>
                    </div>

                    <!---latest-tab--->

                    <div class="tab-pane fade" id="page_tbl" role="tabpanel" aria-labelledby="page-tab">
                        <div class="latest-content pub-content">
                            <div class="pre-loader">
                                <div class="table_public">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Pages</th>
                                                <th style="text-align:center">Mentions</th>
                                                <th style="text-align:center">Visits</th>
                                                <!--                                                <th>Influence Score</th>
                                                                                                <th>Options</th>-->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let mention of pages; let i = index" [style.display]="can_show_mention(mention.id, mention.profile_id)">
                                                <td>{{i+1}}</td>
                                                <td><a href="{{mention.profile_link != null ? mention.link : mention.link}}" target="_blank">{{mention.profile_link != null ? mention.profile_link.split("/")[2] : mention.link.split("/")[2]}}</a></td>
                                                <td style="text-align:center">{{mention.total_count}}</td>
                                                <td style="text-align:center">{{mention.profile_followers_atpost ? mention.profile_followers_atpost : 0}}</td>
                                                <!--                                                <td>John</td>
                                                                                                <td>Doe</td>       -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!--                        <div class="show-more">
                                                    <button type="button" class="submit-mention btn" (click)="show_more_pages()">Show More</button>
                                                </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(199, 28, 109)" type = "square-loader" [fullScreen] = "true"></ngx-spinner>
<app-footer></app-footer>